module.exports = __webpack_public_path__ + "img/greyBin (1).61915542.svg";